import { type FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { useAuthorComments } from "../../../../../../hooks/use-author-comments";
import { useCurrentUser } from "../../../../../../hooks/use-current-user";
import { selectBroadcastId } from "../../../../../../redux/broadcast/broadcast.selectors";
import type { ChatStatuses } from "../chat-module.types";
import Comment from "../comment/comment";

type CommentFeedTypes = {
	status: ChatStatuses;
};

const CommentFeed: FC<CommentFeedTypes> = ({ status }) => {
	const broadcastId = useSelector(selectBroadcastId);
	const currentUser = useCurrentUser();
	const comments = useAuthorComments(broadcastId, currentUser?.uid ?? null);

	const blockedUsers = currentUser?.blockedUsers ?? [];

	const filteredComments = useMemo(() => {
		return comments.filter((comment) => {
			if (blockedUsers.includes(comment.userId)) {
				return false;
			}

			if (status === "unread") {
				return comment.read === false && comment.repliedAt === null;
			}

			if (status === "shared") {
				return comment.sharedToFeed;
			}

			if (status === "archived") {
				return comment.read === true && !comment.sharedToFeed;
			}

			return true;
		});
	}, [comments, status, blockedUsers]);

	if (!broadcastId) return null;

	return (
		<div
			style={{ display: "flex", flexDirection: "column", marginTop: "1.5rem" }}
		>
			{filteredComments.map((comment) => (
				<Comment
					key={comment.id}
					comment={comment}
					broadcastId={broadcastId}
					status={status}
				/>
			))}
		</div>
	);
};

export default CommentFeed;
